<section class="main-section deskContent">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb" style="margin-bottom:30px;">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/workMenOrder/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a routerLink="/admin/sellerDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'WORK_MEN'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"
          *ngIf="user.role === 'ROLE_ADMIN' || user.role === 'SALES_MKTG' || user.role === 'CUSTOMER_CARE'"><a
        routerLink="/admin/adminOrder/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a
        routerLink="/admin/orders/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a
        routerLink="/admin/sellerOrdersList/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/shipmentList/">Shipments</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'WORK_MEN'"><a routerLink="/admin/shipmentList/">Shipments</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">View Order</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3 mb-4">

      <div class="col-6">
        <label class="mr-3" style="font-size:24px;font-weight: 600;margin-top: -6px;">Order#
          {{order.orderNumber}}</label> <span class="v1"></span>
        <label class="ml-3 stus">{{order.orderStatus | replaceStatus}}</label>
        <a (click)="openPopup()" *ngIf="user.role === 'ROLE_ADMIN' || user.role === 'ACCOUNT_OWNER'">&nbsp;&nbsp;
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
              stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>


      </div>
      <div class="col-6 text-right" *ngIf="user.role === 'ROLE_ADMIN' || user.role === 'ACCOUNT_OWNER'">
        <a placement="bottom" ngbTooltip="Track Order" class="ml-2" id="track"
           routerLink="/admin/trackOutBoundOrder/{{order?.orderHeaderId}}"
           *ngIf=" order?.status == 'GENERATE_LABEL'|| order?.status == 'LABEL_GENERATED' || order?.status == 'AWAITING_CARRIER' || order?.status == 'SHIPPED'">
          <img src="assets/images/tracking.png" width="30" height="30" alt="trackImage"/>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)=" tabChange('order');" class="tb"
                                          [ngClass]="{'active': tabClicked === 'order'}">Product</a></li>
          <li class="list-inline-item"><a (click)=" tabChange('orderHistory'); orderActivity()" class="tb"
                                          [ngClass]="{'active': tabClicked === 'orderHistory'}">History</a></li>
          <li class="list-inline-item"><a (click)=" tabChange('productDetails');" class="tb"
                                          [ngClass]="{'active': tabClicked === 'productDetails'}">Package Details</a>
          </li>
          <li class="list-inline-item"><a (click)=" tabChange('addInfo');" class="tb"
                                          [ngClass]="{'active': tabClicked === 'addInfo'}">Additional Info</a></li>

        </ul>
        <div class="inner-box" style="min-height:343px;">
          <div class="row mt-3" *ngIf="tabClicked == 'order'">
            <div class="col-12">
              <div class="box mb-30 p-0">
                <div class="table-responsive">
                  <table class="table table-2">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th *ngIf="user.role ==='WORK_MEN'">Picked Quantity</th>
                      <th *ngIf="user.role ==='PACKER' || user.role ==='WORK_MEN'">Packed Quantity</th>
                      <th *ngIf="order?.status == 'RETURN' || order?.status=='PARTIALLY_RETURN'">Returned
                        Quantity
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let o of lines">
                      <td style="text-transform:uppercase;"><a class=""
                                                               routerLink="/admin/InventoriesView/{{o.productId}}">{{o.sku}}</a>
                      </td>
                      <td>{{o.productName}}</td>
                      <td>{{o.quantity}}</td>
                      <td *ngIf="user.role ==='WORK_MEN'">{{o.scannedQTY || 0}}</td>
                      <td *ngIf="user.role ==='PACKER' || user.role ==='WORK_MEN'">{{o.packedQTY || 0}}</td>
                      <td
                        *ngIf="order?.status == 'RETURN' || order?.status=='PARTIALLY_RETURN'">
                        {{o.returnQuantity || 0}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3" *ngIf="order?.status == 'RETURN' || order?.status=='PARTIALLY_RETURN'">
              <label class="text-black"><b>Return Reason :</b><span
                class="ml-1">{{order?.returnReason}}</span></label>
            </div>
          </div>
          <div class="row mt-3" *ngIf="tabClicked == 'orderHistory'">
            <div class="col-12">
              <div class="box mb-30 p-0">
                <div class="table-responsive">
                  <table class="table table-2">
                    <thead>
                    <tr>
                      <th>Activity</th>
                      <th>Activity Details</th>
                      <th>Date</th>
                      <th>Action By</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let h of orderHistoryActivities">
                      <td>{{h.activity | replaceStatus}}</td>
                      <td>{{h.activityDetails | replaceStatus}}</td>
                      <td>{{h.activityDate}}</td>
                      <td>{{h.createdBy}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" *ngIf="tabClicked == 'productDetails'">
            <div class="col-12">
              <div class="box mb-30 p-0">
                <div class="table-responsive">
                  <table class="table table-2">
                    <thead>
                    <tr>
                      <th>Package Type</th>
                      <th>Box Length</th>
                      <th>Box Height</th>
                      <th>Box Width</th>
                      <th>No.of Boxes</th>
                      <th>Total Weight</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let o of shipLines">
                      <td>{{o.packageType}}</td>
                      <td>{{o.boxLength}}</td>
                      <td>{{o.boxHeight}}</td>
                      <td>{{o.boxWidth}}</td>
                      <td>{{o.numberOfBoxes}}</td>
                      <td>{{o.packageWeight}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" *ngIf="tabClicked == 'addInfo'">
            <div class="col-12">
              <div>
                <label class="text-black"><b>Order# :</b><span class="ml-1"> {{order?.orderNumber}} </span></label><br>
                <label class="text-black" *ngIf="order?.sourceOrderId !== null"><b>Source Order# :</b><span
                  class="ml-1"> {{order?.sourceOrderId}} </span></label><br>
                <label class="text-black" *ngIf="order?.paymentMethod !== null"><b>Payment Method :</b><span
                  class="ml-1"> {{order?.paymentMethod}} </span></label><br>
                <label class="text-black" *ngIf="order?.paymentMethod == 'COD'"><b>Amount :</b><span
                  class="ml-1"> {{order?.totalValue}} </span></label>
              </div>
              <div><label class="text-black" *ngIf="order?.sourceOrderId !== null"><b>Shipment Identifier :</b><span
                class="ml-1"> {{order?.shipmentIdentifier}} </span></label></div>
              <div><label class="text-black" *ngIf="order?.sourceOrderDate !== null"><b>Created Date :</b><span
                class="ml-1"> {{order?.createdDate}} </span></label></div>

              <div>
                <label class="text-black"><b>Carrier Name :</b>
                  <span class="ml-1" *ngIf="!carrierName">{{(order?.shippingOption == 'SD' ? 'Shift' :
              (order?.shippingOption == 'DL' ? 'Delhivery' :
                (order?.shippingOption == 'GT' ? 'Gati' :
                  (order?.shippingOption == 'DZ' ? 'Dotzot' :
                    (order?.shippingOption == 'RD' ? 'Rapid Delivery' :
                      (order?.shippingOption == 'SF' ? 'Shadow Fax' :
                        (order?.shippingOption == 'BD' ? 'Blue Dart' :
                          (order?.shippingOption == 'PR' ? 'Pickrr' :
                            (order?.shippingOption == 'SY' ? 'Ship Yaari' :
                              (order?.shippingOption == 'DE' ? 'Delhivery' :
                                (order?.shippingOption == 'SG' ? 'Shippigo' :
                                  (order?.shippingOption == 'VS' ? 'Vamaship' :
                                    (order?.shippingOption == 'DN' ? 'Dunzo' :
                                      (order?.shippingOption == 'WF' ? 'Borzo' :
                                        (order?.shippingOption == 'FE' ? 'FedEx' : order?.shippingOption)))))))))))))))}}

                  <a (click)="openCarrierName()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>

                </span>

                  <span class="ml-1" *ngIf="carrierName">
                  <input [(ngModel)]="order.shippingOption" [ngModelOptions]="{standalone:true}"
                         class="form-control" id="alterText"
                         type="text"
                         required>
                    <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                      <a (click)="closeCarrierName()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                  </span>
                </label>
              </div>

              <div><label class="text-black"><b>AWB Number :</b>
                <span class="ml-1" *ngIf="!awbNumber"> {{order?.trackingNumbers || "--" }}
                 <a (click)="openAwbNumber()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>
                <span class="ml-1" *ngIf="awbNumber">
                    <input [(ngModel)]="order.trackingNumbers" [ngModelOptions]="{standalone:true}"
                           class="form-control" id="trackingNumber"
                           type="text"
                           required>
                    <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                    <a (click)="closeAwbNumber()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>

              </label>

              </div>


              <div><label class="text-black"><b>Shipment :</b>
                <span class="ml-1"> {{order?.createdDate}}
                   <a (click)="openShipment()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>


                <span class="ml-1" *ngIf="shipmentDate">
                  <input [(ngModel)]="order.createdDate" [ngModelOptions]="{standalone:true}"
                         class="form-control" id="altText"
                         type="date"
                         required>
                    <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                      <a (click)="closeShipment()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>


              </label>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="inner-box" style="min-height:440px;">
          <div class="container my-4">
            <div class="mt-2" style="text-align:center!important;">
              <div class="form-group required mb-0">
                <button type="submit"
                        *ngIf="order.orderStatus == 'IN_PROCESS' || order.orderStatus == 'SKIP_INVOICE' || order.orderStatus == 'PRINT_INVOICE'"
                        (click)="processOrder(order)" class="btn btn-orange" style="height: 38px;">Process Order
                </button>

                <button type="submit" *ngIf="order.orderStatus === 'SUBMITTED' || order.orderStatus === 'LABEL_GENERATED' || order.orderStatus === 'AWAITING_CARRIER'"
                        (click)="generateShippingLabel(order)" class="btn btn-orange" style="height: 38px;">Generate
                  Shipping Label
                </button>

                <button type="submit" *ngIf="order.orderStatus === 'SUBMITTED' || order.orderStatus === 'LABEL_GENERATED' || order.orderStatus === 'AWAITING_CARRIER'"
                        (click)="generateManifest(order)" class="btn btn-orange" style="height: 38px;">Generate Manifest
                </button>
                <button type="submit" *ngIf="order.orderStatus === 'CREATED'"
                        (click)="processOrder(order)" class="btn btn-orange" style="height: 38px;">Process Order
                </button>
                <button type="submit"
                        *ngIf="order.orderStatus === 'IN_PROCESS' ||order.orderStatus === 'SUBMITTED' ||order.orderStatus === 'MANIFEST_GENERATED' ||order.orderStatus === 'LABEL_GENERATED' ||order.orderStatus === 'SKIP_INVOICE' ||order.orderStatus === 'PRINT_INVOICE' ||order.orderStatus === 'CREATED'"
                        (click)="openPopupCancelActivities()" class="btn btn-orange" style="height: 38px;">Cancel Order
                </button>
                <button type="submit"
                        *ngIf="order.orderStatus === 'IN_PROCESS' ||order.orderStatus === 'SUBMITTED' ||order.orderStatus === 'MANIFEST_GENERATED' ||order.orderStatus === 'LABEL_GENERATED' ||order.orderStatus === 'SKIP_INVOICE' ||order.orderStatus === 'PRINT_INVOICE' ||order.orderStatus === 'CREATED'"
                        (click)="openActionPopup()" class="btn btn-orange" style="height: 38px;">Mark as On Hold
                </button>
                <button type="submit"
                        (click)="ReattemptRequestPopupOpen()" *ngIf="order.ndrtagged == 'Yes'" class="btn btn-orange"
                        style="height: 38px;">Reattempt
                </button>
                <button type="submit"
                        (click)="needActionPopupOpen()" *ngIf="order.ndrtagged == 'Yes'" class="btn btn-orange"
                        style="height: 38px;">Request RTO
                </button>
                <button type="submit"
                        (click)="openEscalatePopup()" *ngIf="order.ndrtagged == 'Yes'" class="btn btn-orange"
                        style="height: 38px;">Escalate
                </button>
              </div>
            </div>
            <div class="accordion md-accordion mt-4" id="accordionEx" role="tablist" aria-multiselectable="true">
              <!-- Accordion card -->
              <div class="">
                <!-- Card header -->
                <div class="" role="tab" id="headingOne1">
                  <h5 class="mb-0 title">
                    <a class="a tc" data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1"
                       aria-expanded="true"
                       aria-controls="collapseOne1">
                      Receiver Details
                      <span class="icon"></span>
                    </a>
                  </h5>
                </div>
                <hr>
                <!-- Card body -->
                <div id="collapseOne1" class="collapse show mb-3" role="tabpanel" aria-labelledby="headingOne1"
                     data-parent="#accordionEx">
                  <div class="">
                    <label class="text-black"><span class="ml-1">{{order?.receiverName}}</span></label><br>
                    <label class="text-black mb-2"><span class="ml-1">{{order?.receiverCompanyName}}</span></label><br>
                    <label class="text-black mb-2" *ngIf="order?.receiverMobile"><!--<b>Mobile Number:</b>-->
                      <span class="ml-1" *ngIf="!phone">{{order?.receiverMobile}}
                        <a (click)="openMobileNumber()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>
                      <span class="ml-1" *ngIf="phone">
                  <input [(ngModel)]="order.receiverMobile" [ngModelOptions]="{standalone:true}"
                         class="form-control" id="atText"
                         type="text"
                         required>
                    <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                      <a (click)="closeMobileNumber()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>

                    </label><br>
                    <label class="text-black mb-2" *ngIf="order?.receiverEmail"><span class="ml-1" *ngIf="!email">{{order?.receiverEmail}}
                        <a (click)="openGmail()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                </span>
                      <span class="ml-1" *ngIf="email">
                        <input [(ngModel)]="order.receiverEmail" [ngModelOptions]="{standalone:true}"
                               class="form-control" id="aftText"
                               type="text"
                               required>
                        <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                        <a (click)="closeGmail()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                    </span>
                    </label><br>
                    <label class="text-black" *ngIf="order?.receiverAddressText"><span class="ml-1" *ngIf="!addressUpdate">{{order?.deliveryAddress1}}, {{order?.deliveryAddress2}},<br>{{order?.deliveryCity}},{{order?.deliveryState}},{{order?.deliveryAreaPinCode}}
                      <a (click)="openAddressText()" *ngIf="user.role === 'ROLE_ADMIN'">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.15647 3.1738L9.80318 5.97434M7.33299 1.69826C7.85178 1.07824 8.78437 0.987319 9.41726 1.49556C9.45225 1.52313 10.5765 2.39653 10.5765 2.39653C11.2718 2.81683 11.4878 3.71035 11.058 4.39223C11.0352 4.42874 4.67898 12.3795 4.67898 12.3795C4.46751 12.6433 4.1465 12.7991 3.80343 12.8028L1.36925 12.8333L0.820802 10.512C0.743973 10.1856 0.820802 9.84277 1.03227 9.57896L7.33299 1.69826Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>

                    </span>
                      <span class="ml-1" *ngIf="addressUpdate">
                        <input [(ngModel)]="order.deliveryAddress1" [ngModelOptions]="{standalone:true}"
                               class="form-control" id="deliveryAddress1"  placeholder="Address1"
                               type="text"
                               required><br>
                          <input [(ngModel)]="order.deliveryAddress2" [ngModelOptions]="{standalone:true}"
                                 class="form-control" id="deliveryAddress2" placeholder="Address2"
                                 type="text"
                                 required><br>
                        <div class="col">
              <div class="form-group required">
                <label class="control-label">City</label>
                <ng-select (blur)="typeCity()" [(ngModel)]="order.deliveryCity" [ngClass]="{'is-invalid':cityErrorMessage}"
                           [ngModelOptions]="{standalone: true}" placeholder="updateCity"
                           id="updateCity" required [items]="citiesList"
                           type="text"></ng-select>
                <div [hidden]="!cityErrorMessage" class="invalid-feedback d-block shift-invalid-login">
                  {{cityErrorMessage}}
                </div>
              </div>
            </div>
                        <div class="form-group">
                        <ng-select  (blur)="typeState()" [(ngModel)]="order.deliveryState" [items]="statesList"
                                    [ngClass]="{'is-invalid':statusText4}"
                                    [ngClass]="{'service-error':statusText4}"
                                   [ngModelOptions]="{standalone: true}"
                                   id="updateState"
                                   placeholder="State">
                          <div [hidden]="!statusText4" class="invalid-feedback d-block shift-invalid-login" id="statusText4">
                  {{statusText4}}
                </div>
                              </ng-select>
                        </div>
                          <!--<input [(ngModel)]="updateState" [ngModelOptions]="{standalone:true}"
                                 class="form-control" id="updateState" placeholder="state"
                                 type="text"
                                 required><br>-->
                          <input [(ngModel)]="order.deliveryAreaPinCode" [ngModelOptions]="{standalone:true}"
                                 class="form-control" id="updateZip" placeholder="zip"
                                 type="text"
                                 required>
                        <a class="me-1" (click)="editOrderData(order)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3333 13V10.3333C10.3333 9.96514 10.0349 9.66667 9.66667 9.66667H4.33333C3.96514 9.66667 3.66667 9.96514 3.66667 10.3333V13M9 1V3C9 3.36819 8.70152 3.66667 8.33333 3.66667H5C4.63181 3.66667 4.33333 3.36819 4.33333 3V1M12.4142 3.08088L10.9191 1.58579C10.544 1.21071 10.0353 1 9.50491 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V4.49509C13 3.96466 12.7893 3.45595 12.4142 3.08088Z"
                            stroke="#2196F3" stroke-width="1.5"/>
                        </svg>
                      </a>
                          <a (click)="closeAddressText()">
                        <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" rx="4" fill="none" fill-opacity="0.08"/>
                          <path
                            d="M17.9962 13.9958L14.0028 17.9891M17.9974 17.9915L14.0007 13.994M19.612 8.29184H12.3878C9.87033 8.29184 8.29199 10.0743 8.29199 12.5968V19.4035C8.29199 21.926 9.86283 23.7085 12.3878 23.7085H19.6112C22.137 23.7085 23.7087 21.926 23.7087 19.4035V12.5968C23.7087 10.0743 22.137 8.29184 19.612 8.29184Z"
                            stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>

                    </span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Accordion card -->

              <!-- Accordion card -->
              <div class="">
                <!-- Card header -->
                <div class="" role="tab" id="headingTwo2">
                  <h5 class="mb-0 title">
                    <a class="a collapsed tc" data-toggle="collapse" data-parent="#accordionEx" href="#collapseTwo2"
                       aria-expanded="false" aria-controls="collapseTwo2">Sender Details</a>
                  </h5>
                </div>
                <hr>
                <!-- Card body -->
                <div id="collapseTwo2" class="collapse" role="tabpanel" aria-labelledby="headingTwo2"
                     data-parent="#accordionEx">
                  <label class="text-black"><b></b><span
                    class="ml-1">{{order?.senderName}}</span></label><br>
                  <label class="text-black"><b></b><span
                    class="ml-1">{{order?.senderCompanyName}}</span></label>
                  <label class="text-black"><b></b><span
                    class="ml-1">{{order?.senderMobile}}</span></label>
                  <label class="text-black"><b></b><span
                    class="ml-1">{{order?.senderEmail}}</span></label>
                  <label class="text-black"><b></b><span
                    class="ml-1">{{order?.senderAddressText}}</span></label>
                </div>
              </div>
            </div>
            <!-- Accordion wrapper -->
            <div class="" >
              <label *ngIf="order?.shippingLabelUrl != null"><i class="fa fa-file-pdf-o mr-2" style="color:#8f5cbe;font-weight: 600;"></i><a
                href="{{order?.shippingLabelUrl}}" target="_blank">shipping label </a></label><br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </form>
</section>
<section class="main-section MobileContent">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/workMenOrder/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'WORK_MEN'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminOrder/">Outbound
        Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/orders/">Outbound
        Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/orders/">Orders</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'WORK_MEN'"><a routerLink="/admin/workMenOrder/">Orders</a></li>
      <li class="breadcrumb-item active" aria-current="page">View Outbound Order</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col-12">
        <label class="mr-3" style="font-size:20px;font-weight: 600;margin-top: -6px;">Order#
          {{order?.orderNumber}}</label> <span class="v1"></span><label class="ml-3 stus">{{order.orderStatus |
        replaceStatus}}</label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)=" tabChange('order');" [ngClass]="{'active': tabClicked === 'order'}">Order</a>
          </li>
          <li class="list-inline-item" [hidden]="user.role == 'WORK_MEN' || user.role =='PACKER'"><a
            (click)=" tabChange('orderHistory'); orderActivity()"
            [ngClass]="{'active': tabClicked === 'orderHistory'}">Order History</a></li>
        </ul>
      </div>
    </div>
    <div>
      <div class="" id="accordion">
        <div class="row" *ngIf="tabClicked == 'order'">
          <div class="col-mb-4 col-md-6">
            <div class="inner-box"
                 [hidden]="(user.role == 'WORK_MEN' || user.role =='PACKER') && order?.status == 'TOTE_ASSIGNED' || order?.status == 'PRODUCT_ALLOTTED' || order?.status == 'PRODUCT_PACKED'">
              <div class="" [hidden]="user.role == 'WORK_MEN' || user.role =='PACKER'">
                <label>Create date:</label>
                <div class="accordion md-accordion" id="maccordionEx" role="tablist" aria-multiselectable="true">
                  <!-- Accordion card -->
                  <div class="">
                    <!-- Card header -->
                    <div class="" role="tab" id="headingOne1m">
                      <h5 class="mb-0 title">
                        <a class="a tc" data-toggle="collapse" data-parent="#maccordionEx" href="#collapseOne1m"
                           aria-expanded="true"
                           aria-controls="collapseOne1m">

                          Receiver Details <span class="icon"></span>

                        </a>
                      </h5>
                    </div>
                    <hr>
                    <!-- Card body -->
                    <div id="collapseOne1m" class="collapse show mb-3" role="tabpanel" aria-labelledby="headingOne1m"
                         data-parent="#maccordionEx">
                      <div class="">
                        <label class="text-black"><b></b><span
                          class="ml-1">{{order?.receiverName}}</span></label><br>
                        <label class="text-black"><b></b><span
                          class="ml-1">{{order?.receiverAddressText}}</span></label><br>
                        <label class="text-black mb-2"><b></b><span
                          class="ml-1"> {{order?.receiverCompanyName}}</span></label><br>
                        <label class="text-black mb-2"><b></b><span
                          class="ml-1"> {{order?.receiverMobile}}</span></label><br>
                        <label class="text-black mb-2"><b></b><span
                          class="ml-1"> {{order?.receiverEmail}}</span></label>
                      </div>
                    </div>

                  </div>
                  <!-- Accordion card -->

                  <!-- Accordion card -->
                  <div class="">

                    <!-- Card header -->
                    <div class="" role="tab" id="headingTwo2m">
                      <h5 class="mb-0 title">
                        <a class="a collapsed tc" data-toggle="collapse" data-parent="#maccordionEx"
                           href="#collapseTwo2m"
                           aria-expanded="false" aria-controls="collapseTwo2m">
                          Sender Details
                          <span class="icon"></span>
                          <!--<label class="text-black class="text-black">Shipping Label</lable>-->
                        </a>
                      </h5>
                    </div>
                    <hr>
                    <!-- Card body -->
                    <div id="collapseTwo2m" class="collapse" role="tabpanel" aria-labelledby="headingTwo2m"
                         data-parent="#maccordionEx">
                      <label class="text-black"><b></b><span
                        class="ml-1">{{order?.senderName}}</span></label><br>
                      <label class="text-black"><b></b><span
                        class="ml-1">{{order?.senderAddressText}}</span></label>
                      <label class="text-black"><b></b><span
                        class="ml-1">{{order?.senderCompanyName}}</span></label>
                      <label class="text-black"><b></b><span
                        class="ml-1">{{order?.senderMobile}}</span></label>
                      <label class="text-black"><b></b><span
                        class="ml-1">{{order?.senderEmail}}</span></label>
                    </div>
                  </div>
                </div>
                <!-- Accordion wrapper -->
              </div>

              <div class="mt-4" style="text-align:center!important;">
                <div class="form-group required mb-0">
                  <button type="submit"
                          (click)="generateManifest(order)" class="btn btn-orange ml-2" style=" height: 38px;">Generate
                    Manifest
                    order
                  </button>
                </div>
              </div>
            </div>

            <div class="inner-box">
              <div class="accordion md-accordion" id="maccordionEx1" role="tablist" aria-multiselectable="true">

                <!-- Accordion card -->
                <div class="" [hidden]="user.role == 'WORK_MEN' || user.role =='PACKER'">

                  <!-- Card header -->
                  <div class="" role="tab" id="headingOne1mr">
                    <h5 class="mb-0 title">
                      <a class="a collapsed tc" data-toggle="collapse" data-parent="#maccordionEx1"
                         href="#collapseOne1mr" aria-expanded="true"
                         aria-controls="collapseOne1mr">

                        Order Details <span class="icon"></span>

                      </a>
                    </h5>
                    <div class="col-md-3">
                      <h2 class="text-black mb-2 review d-none d-sm-block">Account Owner Details</h2>
                    </div>
                    <div class="col-md-3">
                      <h2 class="text-black mb-2 review d-none d-sm-block">Contact Details</h2>
                    </div>
                    <div class="col-md-3">
                      <h2 class="text-black mb-2 review d-none d-sm-block">Warehouse Details
                      </h2>

                    </div>
                  </div>
                  <hr>
                  <!-- Card body -->
                  <div id="collapseOne1mr" class="collapse mb-3" role="tabpanel" aria-labelledby="headingOne1mr"
                       data-parent="#maccordionEx1">
                    <div class="ml-3">
                      <label class="text-black"><b>Order# :</b></label><span
                      class="ml-1"> {{order?.orderNumber}} </span><br>
                      <label class="text-black"><b>Source Order Num :</b></label><span
                      class="ml-1"> {{order?.sourceOrderId}} </span><br>
                      <label class="text-black"><b>Source Order Date :</b></label><span
                      class="ml-1"> {{order?.sourceOrderDate}} </span><br>
                      <label class="text-black"><b>Source Status :</b></label><span
                      class="ml-1"> {{order?.providerStatus || '--'}} </span><br>
                      <label class="text-black"><b>Channel/Source :</b></label><span
                      class="ml-1"> {{(order?.connectionName ? (order?.connectionName + '/') : '') | titlecase}}{{order?.channelName | titlecase}} </span><br>
                      <label class="text-black"><b>Order Date : </b></label><span
                      class="ml-1"> {{order?.orderedDate}}</span><br>
                      <label class="text-black"><b>Order Status :</b></label><span
                      class="ml-1"> {{((order?.status == 'SUBMITTED' ? 'Submitted' :
                      (order?.status == 'PROCESSING' ? 'Processing' :
                        (order?.status == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                          (order?.status == 'SHIPPED' ? 'Shipped' :
                            (order?.status == 'PACKER_ASSIGNED' ? 'Packer Assigned' :
                              (order?.status == 'COMPLETED' ? 'Completed' :
                                (order?.status == 'CANCELLED' ? 'Cancelled' :
                                  (order?.status == 'EXCEPTION' ? 'Exception' :
                                    (order?.status == 'TO_PICK' ? 'Ready to Pick' :
                                      (order?.status == 'PICK_ASSIGNED' ? 'Picker Assigned' :
                                        (order?.status == 'TO_PACK' ? 'To pack' :
                                          (order?.status == 'GENERATED' ? 'Generated' :
                                            (order?.status == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                                              (order?.status == 'IN_TRANSIT' ? 'In Transit' :
                                                (order?.status == 'GENERATE_LABEL' ? 'Generate Label' :
                                                  (order?.status == 'TOTE_ASSIGNED' ? 'Tote Assigned' :
                                                    (order?.status == 'LABEL_GENERATED' ? 'Label Generated' :
                                                      (order?.status == 'ON_HOLD' ? 'On Hold' :
                                                        (order?.status == 'PRODUCT_ALLOTTED' ? 'Product Allotted' :
                                                          (order?.status == 'PARTIALLY_RETURN' ? 'Partially Return' :
                                                            (order?.status == 'RETURN' ? 'Return' :
                                                              (order?.status == 'UN_HOLD' ? 'Hold Released' : order?.status
                                                              )))))))))))))))))))))) + (!order?.isInvoiced ? ' - No Invoice' : ''))|replaceStatus}}</span>
                    </div>
                    <div class="col-md-3">
                      <h2 class="text-black mt-4 mt-md-0 mb-2 review d-block d-sm-none">Account Owner Details</h2>
                      <hr class="d-block d-sm-none"/>
                      <label class="text-black"><b>Company Name :</b></label><span
                      class="ml-1">{{order?.accountOwnerCompany}}</span><br>
                      <label class="text-black"><b>Name :</b></label><span
                      class="ml-1">{{order?.accountOwnerName}}</span><br>
                    </div>
                    <div class="col-md-3">
                      <h2 class="text-black mt-4 mt-md-0 mb-2 review d-block d-sm-none">Contact Details</h2>
                      <hr class="d-block d-sm-none"/>
                      <label class="text-black"><b>Contact Name :</b></label><span
                      class="ml-1">{{order?.accountOwnerCustomerName}}</span><br>
                      <label class="text-black"><b>Contact Address :</b></label><span
                      class="ml-1">{{order?.addressText}}</span><br>
                      <label class="text-black mb-2"><b>Company Name : </b></label><span
                      class="ml-1"> {{order?.accountOwnerCustomerCompanyName}}</span><br>
                      <label class="text-black mb-2"><b>Phone Number : </b></label><span
                      class="ml-1"> {{order?.accountOwnerCustomerPhone}}</span><br>
                      <label class="text-black mb-2"><b>Email : </b></label><span
                      class="ml-1"> {{order?.accountOwnerCustomerEmail}}</span>
                    </div>
                    <div class="col-md-3">
                      <h2 class="text-black mt-4 mt-md-0 mb-2 review d-block d-sm-none">Warehouse Details</h2>
                      <hr class="d-block d-sm-none"/>
                      <label class="text-black"><b>Warehouse :</b></label><span
                      class="ml-1">{{order?.sourceWarehouseName}}</span><br>
                      <label class="text-black"><b>Warehouse Address :</b></label><span
                      class="ml-1">{{order?.warehouseAddressText}}</span>
                    </div>
                  </div>
                </div>


                <!-- Accordion card -->

                <!-- Accordion card -->
                <div class="">

                  <!-- Card header -->
                  <div class="" role="tab" id="headingTwo2mp">
                    <h5 class="mb-0 title">
                      <a class="a tc" data-toggle="collapse" data-parent="#maccordionEx1" href="#collapseTwo2mp"
                         aria-expanded="false" aria-controls="collapseTwo2mp">

                        Product Details
                        <span class="icon"></span>


                      </a>
                    </h5>
                  </div>
                  <hr>
                  <!-- Card body -->
                  <div *ngFor="let o of lines" id="collapseTwo2mp" class="collapse show" role="tabpanel"
                       aria-labelledby="headingTwo2mp"
                       data-parent="#maccordionEx1">

                    <div class="parent">
                      <div class="img">
                        <img class="d-md-none d-sm-none d-xs-none d-lg-block shift-uploaded-img"
                             src="https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png"/>
                      </div>
                      <div class="text">
                        <h6 style="margin-bottom: 5px!important;"> {{o.productName}}</h6>
                        <p><a class="" routerLink="/admin/InventoriesView/{{o.productId}}">{{o.sku}}</a></p>

                        <div style="display: flex;" *ngIf="order?.status !== 'PRODUCT_PACKED'">
                          <p style="margin-right: 50px;">{{o.scannedQTY}} out of {{o.quantity}}</p>
                          <p class="red" *ngIf="o.scannedQTY !== o.quantity">{{(o.quantity || 0) - (o.scannedQTY || 0)}}
                            pending</p>
                        </div>
                        <div style="display: flex;" *ngIf="order?.status == 'PRODUCT_PACKED'">
                          <p style="margin-right: 50px;">{{o.packedQTY}} out of {{o.quantity}}</p>
                          <p class="red" *ngIf="o.packedQTY !== o.quantity">{{(o.quantity || 0) - (o.packedQTY || 0)}}
                            pending</p>
                        </div>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="row" *ngIf="tabClicked == 'orderHistory'">
          <div class="col-12">
            <div class="inner-box mb-30 p-0">
              <div class="table-responsive">
                <table class="table table-2">
                  <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Date</th>
                    <th>Action By</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let h of orderHistoryActivities">
                    <td>{{h.activity | replaceStatus}}</td>
                    <td>{{h.activityDetails | replaceStatus}}</td>
                    <td>{{h.activityDate}}</td>
                    <td>{{h.createdBy}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </form>


</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button *ngIf="user.role == 'WORK_MEN'" type="submit" (click)="goBack()" class="btn btn-cancel">
        Close
      </button>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': pdfGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pdfGenerate == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Select Size</h5>
        <button type="button" id="enterQuantity" class="close" (click)="close()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <label class="control-label" for="printSize2">Print Size Option</label>
                <select class="form-control" id="printSize2" [(ngModel)]="size" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':sizeError}" required>
                  <option value="Custom">Label Printer (101mm X 150mm)</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!sizeError">{{sizeError}}</div>
              </div>
            </div>
            <div class="col-4 mt-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printShipment(order)">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': needActionPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': needActionPopup == 'Y'}" class="modal" id="needActionPopUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="needActionLabe">Return to Order</h5>
        <button type="button" class="close" (click)="closeNeedActionPopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <label class="control-label" for="cancelReason">Reason</label>
              <select id="cancelReason" class="form-control" [(ngModel)]="needActionReason"
                      [ngModelOptions]="{standalone: true}" required>
                <option *ngFor="let c of actionReasons" [ngValue]="c.config">{{c.label}}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label" for="description">Notes</label>
              <textarea id="description" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeNeedActionPopUp()">Cancel</button>
              <button type="submit" class="btn btn-orange2 ml-1">Request RTO</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div [ngStyle]="{'display': ReattemptRequestPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': ReattemptRequestPopup == 'Y'}" class="modal" id="ReattemptRequestPopup" tabindex="-1"
     role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="ReattemptRequest">Reattempt Request</h5>
        <button type="button" class="close" (click)="closeReattemptRequestPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Customer Details</b></h2>
                <div class="row mt-3">
                  <div class="col-lg-4 col-sm-6">
                    <label class="text-black">{{viewCustomer?.ownerName | titlecase}}</label>
                    <label class="text-black">{{viewCustomer?.email}}</label>
                    <label class="text-black">{{viewCustomer?.mobile}}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngFor="let add of viewCustomer.adddressList">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Current Address & Delivery</b></h2>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label class="text-black">{{add.addressType | titlecase}}</label><br>
                    <label class="text-black">{{add.address1}}</label><br>
                    <label class="text-black">{{add.address2}}</label><br>
                    <label class="text-black">{{add.city}}</label><br>
                    <label class="text-black">{{add.state}}</label><br>
                    <label class="text-black">{{add.zip}}</label><br>
                    <label class="text-black"><b>Date</b> : 25-10-2021</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <label class="control-label">Notes</label>
              <textarea id="descriptionR" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeReattemptRequestPopup()">Cancel</button>
              <button type="submit" class="btn btn-orange2 ml-1">Request</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display':  escalatePopup=='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': escalatePopup == 'Y'}" class="modal" id="escalatePopup" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="escalatePopupTitle">Escalate</h5>
        <button type="button" class="close" (click)="closeEscalatePopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label">Notes</label>
              <textarea id="descriptionE" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeEscalatePopup()">Cancel</button>
              <button type="submit" class="btn btn-orange2 ml-1">save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': cancelActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': cancelActivities == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Cancel Order</h5>
        <button type="button" class="close" (click)="closepopUpRequest()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label class="control-label" for="cancelReason">Cancel Reason</label>
                  <select id="cancelReasons" class="form-control" [(ngModel)]="reason"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let c of cancelReasons" [ngValue]="c.config">{{c.config}}</option>
                  </select>
                  <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!cancelError">
                    {{cancelError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closepopUpRequest()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="cancelOrder()">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': orderActionPopup == 'Y'}" [ngStyle]="{'display': orderActionPopup  =='Y'? 'block' : 'none'}"
     style="overflow-y:auto" class="modal fade show" id="exampleModal" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true" style="padding-top:100px;">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="closeOrderActionPopup()">&times;</button>
      </div>
      <div class="modal-body">
        <label class="mb-3">Do you want hold the Order? </label>
      </div>
      <div class="modal-footer">
        <button (click)="closeOrderActionPopup()" class="btn btn-cancel" type="button">No</button>
        <button (click)="holdOrder()" class="btn icon-left btn-orange-primary ml-3" type="button">Yes
        </button>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': Status =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': Status == 'Y'}" class="modal" id="Popup" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="PopupTitle">Update Status</h5>
        <button type="button" class="close" (click)="closePopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="input-outer">
                <select class="form-control" id="editStatus"  [ngClass]="{'is-invalid':statusError}"
                        (change)="clearStatus()" [ngClass]="{'service-error':statusError}" [(ngModel)]="editStatus" [ngModelOptions]="{standalone: true}" (change)="clearStatus()"
                        required>
                  <option value="IN_TRANSIT">In Transit</option>
                  <option value="DELIVERED">Delivered</option>
                  <option value="RETURN_TO_ORIGIN">Return To Origin</option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12" *ngIf="editStatus == 'IN_TRANSIT'">
                <label>pick up date</label>
                <input type="date" class="form-control" placeholder="pickUpDate" [ngClass]="{'is-invalid':pickUPDateError}"
                       [ngClass]="{'service-error':pickUPDateError}" [(ngModel)]="pickUpDate" [ngModelOptions]="{standalone: true}">
              </div>
              <div class="col-md-12" *ngIf="editStatus == 'DELIVERED'">
                <label>Delivery Date</label>
                <input type="date" class="form-control" placeholder="deliveryDate" [ngClass]="{'is-invalid':deliveryDate}"
                       [ngClass]="{'service-error':deliveryDate}" [(ngModel)]="delivered" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="row mt-3" *ngIf="editStatus == 'RETURN_TO_ORIGIN'">
              <div class="col-md-6">
                <input type="text" class="form-control" placeholder="Reason" [ngClass]="{'is-invalid':reasonError}"
                       [ngClass]="{'service-error':reasonError}" [(ngModel)]="reason" [ngModelOptions]="{standalone: true}">
              </div>
              <div class="col-md-6">
                <input type="text" class="form-control" placeholder="Shipment Cost" [ngClass]="{'is-invalid':shipmentCostError}"
                       [ngClass]="{'service-error':shipmentCostError}" [(ngModel)]="shipmentCost" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-orange2 me-2" (click)="updateStatus()"> save
            </button>
            <button type="button" class="btn btn-cancel" (click)="closePopup()"> cancel
            </button>
          </div>
        </div>
    </div>
  </div>
</div>
